import { Card, CardContent } from "@/components/ui/card";

export default function ContactInbox({ messages }) {
  return (
    <div className="mt-4 space-y-3">
      {messages.map((m) => (
        <Card key={m.message_id} className="border-black/5" data-testid={`admin-msg-${m.message_id}`}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <strong>{m.subject}</strong>
              <span className="text-xs text-[color:var(--text-secondary)]">{new Date(m.created_at).toLocaleString()}</span>
            </div>
            <div className="text-sm text-[color:var(--text-secondary)] mt-1">{m.name} &lt;{m.email}&gt;</div>
            <p className="mt-3 text-sm leading-relaxed">{m.message}</p>
          </CardContent>
        </Card>
      ))}
      {messages.length === 0 && <p className="text-sm text-[color:var(--text-secondary)]">No contact messages.</p>}
    </div>
  );
}
